<template>
    <div class="client profile">
        <vs-tabs alignment="left" position="top" class="extended">
            <vs-tab icon="account_circle" label="Información">
                <div>
                    <div class="editar" v-if="userInfoData.role == Roles.Admin">
                        <router-link :to="`/customer/manage/${customer.id}`"><feather type="edit-2"/>Editar Cliente</router-link>
                    </div>
                    <div class="picture">
                        <vs-avatar :src="profileImg" size="120px"/>
                        <div class="info">
                            <p>{{ customer.firstName + ' ' + customer.lastName }}</p>
                            <span>{{ customer.email }}</span>
                            <div class="client-status">
                                <div :class="['circle', customer.statuscode === 0 ? 'danger' : 'success' ]"></div>
                                {{customer.statusname | capitalize}}
                            </div>
                        </div>
                    </div>
                    <div class="wrap-detail-account">
                        <div class="title"><h2>Detalle de la cuenta</h2></div>
                        <div class="detail">
                            <h3>Casillero: </h3>
                            <p>{{ customer.typename }}</p>
                        </div>
                        <div class="detail">
                            <h3>Fecha Ingreso: </h3>
                            <p>{{ customer.createdAt | moment("DD/MM/YYYY") }}</p>
                        </div>
                        <div class="detail">
                            <h3>Profesión: </h3>
                            <p>{{ customer.profession }}</p>
                        </div>
                        <div class="detail">
                            <h3>Cédula o pasaporte: </h3>
                            <p>{{ customer.identification }}</p>
                        </div>
                        <div class="detail">
                            <h3>Teléfono: </h3>
                            <p>{{ customer.mobile }} / {{ customer.phone }}</p>
                        </div>
                        <div class="detail">
                            <h3>Fecha Nacimiento: </h3>
                            <p>{{ customer.birthdate | moment("DD/MM/YYYY") }}</p>
                        </div>
                        <div class="detail" v-if="customer.typecode == '03'">
                            <h3>Cod Membresía: </h3>
                            <p> MS-{{ customer.id }}</p>
                        </div>
                    </div>
                    <div class="wrap-delivery">
                        <div class="title">
                            <h2>Información Geográfica</h2>
                        </div>
                        <div class="detail">
                            <h3>Provincia: </h3>
                            <p>{{ customer.pvname | capitalize }}</p>
                        </div>
                        <div class="detail">
                            <h3>Cantón: </h3>
                            <p>{{ customer.ctname | capitalize }}</p>
                        </div>
                        <div class="detail">
                            <h3>Distrito: </h3>
                            <p>{{ customer.dtname | capitalize }}</p>
                        </div>
                        <div class="address">
                            <h3>Dirección: </h3>
                            <p>{{ customer.address }}</p>
                        </div>
                        <div class="detail">
                            <h3>Entrega: </h3>
                            <p>{{ customer.dlvName }}</p>
                        </div>
                        <div class="detail">
                            <h3>Notificar: </h3>
                            <p>{{ notificationInfo() }}</p>
                        </div>
                    </div>
                </div>
            </vs-tab>
            <vs-tab icon="shopping_cart" label="Compras" v-if="userInfoData.role == Roles.Admin">
                <div class="" v-if="packages.length > 0">
                    <vs-table search :data="packages" pagination max-items="10">
                        <template slot="thead">
                            <vs-th sort-key="tracking">Nro Tracking</vs-th>
                            <vs-th sort-key="name">Peso </vs-th>
                            <vs-th sort-key="costototal">Price </vs-th>
                            <vs-th sort-key="comments">Comentarios </vs-th>
                            <vs-th sort-key="created"> Fecha Registro </vs-th>
                            <vs-th sort-key="status"> Estado </vs-th>
                            <vs-th sort-key="id" class="width-30"></vs-th>
                        </template>
                        <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                            <vs-td :data="data[indextr].tracking">
                                {{data[indextr].tracking}}
                            </vs-td>
                            <vs-td :data="data[indextr].name">
                                {{ data[indextr].weight +" "+ data[indextr].unit }}
                            </vs-td>
                            <vs-td :data="data[indextr].costototal">
                                <p v-if="data[indextr].costototal != null && data[indextr].costototal != 'NaN'">
                                    ${{ formatNumber(data[indextr].costototal)}}
                                </p>
                            </vs-td>
                            <vs-td :data="data[indextr].comments">
                                {{data[indextr].comments}}
                            </vs-td>
                            <vs-td :data="data[indextr].created">
                                {{data[indextr].createdAt | moment('DD/MM/YYYY')}}
                            </vs-td>
                            <vs-td :data="data[indextr].statuscode">
                                <span :class="`status status-${data[indextr].statuscode}`" @click="changePackageStatus(data[indextr].id)">
                                    {{data[indextr].displayName}}
                                </span> 
                            </vs-td>
                            <vs-td :data="data[indextr].id">
                                <div class="table-actions">
                                    <router-link :to="`/package/${data[indextr].id}`"><feather type="eye"/></router-link>
                                </div>
                            </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </div> 
                <displayInformation  v-if="packages.length < 1" message="El cliente no tiene paquetes registrados" :showButton="false"></displayInformation>
            </vs-tab>
            <vs-tab icon="attach_money" label="Costo Preferencial" v-if="userInfoData.role == Roles.Admin">
                <div class="form">
                    <div :class="['form-input', {'has-error': $v.customerRate.$error }]">
                        <vs-input type="text" label="Costo por libra" v-model="$v.customerRate.$model"/>
                        <span class="error-text" v-if="$v.customerRate.$error"><feather type="info" />Este campo es requerido</span>
                    </div> 
                    <div class="form-input footer">
                        <vs-button id="btnConfirm" color="success" type="border"
                        @click="updateRateLocker" class="vs-con-loading__container">Actualizar</vs-button>
                    </div>
                </div>
            </vs-tab>
            <vs-tab icon="security" label="Cambiar Contraseña" v-if="userInfoData.role == Roles.Admin">
                <div class="form">
                    <div :class="['form-input', {'has-error': $v.objChangePass.newpassword.$error }]">
                        <vs-input type="password" label="Nueva Contraseña" v-model="$v.objChangePass.newpassword.$model"/>
                        <span class="error-text" v-if="$v.objChangePass.newpassword.$error"><feather type="info" />Las contaseñas no coinciden.</span>
                    </div>
                    <div :class="['form-input', {'has-error': $v.objChangePass.confirmPass.$error }]">
                        <vs-input type="password" label="Confirmar Nueva Contraseña" v-model="$v.objChangePass.confirmPass.$model"/>
                        <span class="error-text" v-if="$v.objChangePass.confirmPass.$error"><feather type="info" />Las contaseñas no coinciden.</span>
                    </div>
                    <div class="form-input footer">
                        <vs-button :disabled="$v.objChangePass.$invalid" id="btnConfirm" color="success" type="border"
                        @click="changePassword" class="vs-con-loading__container">Actualizar</vs-button>
                    </div>
                </div>
            </vs-tab>
            <vs-tab icon="assignment" label="Cashback" v-if="userInfoData.role == Roles.Admin">
                
                <vs-alert :active="!isFranquise && userInfoData.role == Roles.Admin">
                    Lo sentimos, el cliente selecciondo no cuenta cashback habilitado.
                </vs-alert>
                
                <vs-table search :data="cashbackData" pagination max-items="10"  v-if="userInfoData.role == Roles.Admin && isFranquise">
                    <template slot="header">
                        <vs-button @click="openModal()" color="primary" type="border" icon="library_add">Agregar Cashback</vs-button>
                    </template>
                    <template slot="thead">
                        <vs-th sort-key="amount">Monto</vs-th>
                        <vs-th sort-key="month">Fecha </vs-th>
                        <vs-th sort-key="statusname"> Estado </vs-th>
                        <vs-th sort-key="id" class="width-30"></vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                        <vs-td :data="data[indextr].amount">
                            ${{data[indextr].amount}}
                        </vs-td>
                        <vs-td :data="data[indextr].month">
                            {{ data[indextr].monthName +", "+ data[indextr].year }}
                        </vs-td>
                        <vs-td :data="data[indextr].statusname">
                            {{data[indextr].statusname}}
                        </vs-td>
                        <vs-td :data="data[indextr].id" v-if="userInfoData.role == Roles.Admin">
                            <div class="table-actions" v-if="data[indextr].statuscode == stCashbackPending">
                                <a href="javascript:void(0)" class="" @click="editCashback(data[indextr].id, indextr)"><feather type="edit-2"/></a>
                            </div>
                        </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </vs-tab>
            <vs-tab icon="assignment" label="Contactos" v-if="userInfoData.role == Roles.Admin">

                <vs-table :key="key" search :data="contacts" pagination max-items="10"  v-if="userInfoData.role == Roles.Admin">
                    <template slot="header">
                        <vs-button @click="openModalContact()" color="primary" type="border" icon="library_add">Agregar Contacto</vs-button>
                    </template>
                    <template slot="thead">
                        <vs-th sort-key="amount">Nombre</vs-th>
                        <vs-th sort-key="month">Correo </vs-th>
                        <vs-th sort-key="id" class="width-30"></vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                        <vs-td :data="data[indextr].name">{{data[indextr].name}}</vs-td>
                        <vs-td :data="data[indextr].statusname">{{data[indextr].email}}</vs-td>
                        <vs-td :data="data[indextr].id" v-if="userInfoData.role == Roles.Admin">
                            <div class="table-actions">
                                <a href="javascript:void(0)" class="" @click="editContact(data[indextr], indextr)"><feather type="edit-2"/></a>
                                <a href="javascript:void(0)" class="" @click="removeContact(indextr)"><feather type="trash-2"/></a>
                            </div>
                        </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </vs-tab>
        </vs-tabs>
        <modalPackage @modal-event="handleActionModalPackage" :packID="packageId" :selected="pkgCurrentStatus" :show="modalActive"></modalPackage>
        
        <transition name="fade">
            <modalBasic :show="ModalActive">
                <div class="modal-header" slot="modal-header">{{ ModalTitle }}</div>
                <div class="modal-body" slot="modal-body">
                    <form>
                        <div :class="['form-input', {'has-error': $v.cashback.amount.$error }]" >
                            <vs-input label="Monto" v-model.trim="$v.cashback.amount.$model"/>
                            <span class="error-text" v-if="$v.cashback.amount.$error"><feather type="info" />Este campo es requerido</span>
                        </div>
                        <div :class="['form-input', {'has-error': $v.cashback.month.$error }]" >
                            <label class="vs-input--label">Mes</label>
                            <select-input :options="months" v-model="$v.cashback.month.$model"></select-input>
                            <span class="error-text" v-if="$v.cashback.month.$error"><feather type="info" />Este campo es requerido</span>
                        </div>
                        <div :class="['form-input', {'has-error': $v.cashback.status }]" v-if="isUpdating">
                            <label class="vs-input--label">Estado</label>
                            <select-input :options="status" v-model="cashback.status"></select-input>
                        </div>
                    </form>
                </div>
                <div class="modal-footer" slot="modal-footer">
                    <vs-button color="danger" type="border" icon="block"  @click="closeModal()">Cancelar</vs-button>
                    <vs-button :disabled="confirmStatus || $v.cashback.$invalid" id="btnConfirm" color="success" type="border" icon="check" 
                        @click="handleRequestCashback" class="vs-con-loading__container"> {{ !isUpdating ? 'Guardar' : 'Actualizar' }}</vs-button>
                </div>
            </modalBasic>
         </transition>

         <modalBasic :show="ModalContact">
                <div class="modal-header" slot="modal-header">{{ ModalContactTitle }}</div>
                <div class="modal-body" slot="modal-body">
                    <form>
                        <div :class="['form-input', {'has-error': $v.contact.name.$error }]" >
                            <vs-input label="Nombre" v-model.trim="$v.contact.name.$model"/>
                            <span class="error-text" v-if="$v.contact.name.$error"><feather type="info" />Este campo es requerido</span>
                        </div>
                        <div :class="['form-input', {'has-error': $v.contact.email.$error }]" >
                            <vs-input label="Correo" v-model.trim="$v.contact.email.$model"/>
                            <span class="error-text" v-if="$v.contact.email.$error"><feather type="info" />Este campo es requerido</span>
                        </div>
                    </form>
                </div>
                <div class="modal-footer" slot="modal-footer">
                    <vs-button color="danger" type="border" icon="block"  @click="closeModalContact()">Cancelar</vs-button>
                    <vs-button :disabled="confirmStatus || $v.contact.$invalid" id="btnConfirm" color="success" type="border" icon="check" 
                        @click="handleRequestContact" class="vs-con-loading__container"> {{ !isUpdating ? 'Guardar' : 'Actualizar' }}</vs-button>
                </div>
            </modalBasic>

    </div>
</template>
<script>
import {helper} from '@/helpers/utils'
import { Role } from '@/helpers/Role.js'
import { mapState, mapActions } from 'vuex'
import Customer from "@/models/ClientModel"
import ContactModel from "@/models/ContactModel"
import CashbackModel from "@/models/CashbackModel"
import ModalBasic from '@/components/Modal/Basic.vue'
import UserDataService from "@/services/UserDataService"
import SelectInput from '@/components/Form/Select-Input.vue'
import ClientDataService from "@/services/ClientDataService"
import ModalPackage from '@/components/Modal/PackageStatus.vue'
import CashbackDataService from "@/services/CashbackDataService"
import DisplayInformation from '@/components/DisplayInformation.vue'
import { required, sameAs, minLength } from 'vuelidate/lib/validators'
export default {
  name: "Customer",
  mixins: [helper],
  components:{
    ModalPackage,
    ModalBasic,
    SelectInput,
    DisplayInformation
  },
  data () {
    return {
      packageId: "",
      pkgCurrentStatus:{},
      modalActive: false,
      customer: new Customer(),
      profileImg: "",
      changePwdStatus: false,
      customerRate: 0,
      objChangePass: {
          valpwd: 0,
          email: '',
          newpassword: '',
          confirmPass: '',
      },
      packages: [],
      Roles:{},
      months: [],
      confirmStatus: false,
      cashbackData: [],
      isUpdating: false,
      ModalTitle: 'Agregar Cashback',
      ModalActive: false,
      stCashbackPending: 8,
      cashback: new CashbackModel(),
      cashbackIndex: 0,
      status: [],
      isFranquise: false,
      contacts:[],
      ModalContactTitle: "Agregar Contacto",
      ModalContact : false,
      contact: new ContactModel(),
      key: 1,
      contactId: ""
    
    }
  },
  computed: {
    ...mapState([
      'userInfoData'
    ]),
  },
  created(){
    this.Roles = Role
    
    this.retrieveCustomer(this.$route.params.id)
  },
  mounted (){
    // this.retrieveCustomer(this.$route.params.id)
    this.retrieveMonths()
    this.retrieveStatus()
  },
  validations: {
    objChangePass: 
        {   
            email: { required },
            newpassword: 
            { 
                required,
                minLength: minLength(6)
            },
            confirmPass: { sameAsPassword: sameAs('newpassword') }
        },
    customerRate: {required},
    cashback: {
        amount: {required},
        month:  {required},
        customer: {required}
    },
    contact: {
        name: {required},
        email:  {required},
    },
  },
  methods: {
    // isFranquise (){
    //     let response = this.customer.typecode == '03' ? true : false
    //     console.log('response', response)
    //     return this.customer.typecode == '03' ? true : false
    // },
    openModal () {
        this.ModalActive = true
        this.isUpdating  = false
        this.cashback.customer = this.customer.id
        this.$v.$reset()
    },
    closeModal () {
        this.ModalTitle  = 'Agregar Cashback'
        this.ModalActive = false
        this.cashback    = new CashbackModel()
        this.$v.$reset()
        this.showPassInput = true
    },
    editCashback (id, index) {
        this.ModalTitle  = "Editar Cashback"
        this.ModalActive = true
        this.cashbackIndex = index
        this.cashback    = this.searchCasback(id)
        this.isUpdating  = true
    },
    handleActionModalPackage(response){
      if(response.error !=  undefined){
        if(!response.error){
            this.retrieveCustomer(this.$route.params.id)
            this.$vs.notify({title:'Información!',text:'El estado del paquete fue modificado exitosamente!',color:'success',icon:'check'})
        }else{
            this.$vs.notify({title:'Información!',text:'Error actualizando el estado del paquete',color:'danger',icon:'error_outline'})
        }
      }
      this.modalActive = response.active
      
    },
    openModalContact () {
        this.ModalContact = true
        this.isUpdating  = false
        this.contact.customerId = this.customer.id;
        this.ModalContactTitle = "Agregar Contacto";
        this.$v.contact.$reset()
    },
    closeModalContact () {
        this.ModalContact = false
        this.ModalContactTitle = "Agregar Contacto";
        this.contact = new ContactModel()
        this.$v.contact.$reset()
    },
    editContact (_contact, index) {
        console.log(index);
        this.ModalContactTitle  = "Editar Contacto"
        this.ModalContact  = true
        this.contact     = { ..._contact }
        this.isUpdating  = true
    },
    removeContact(index){
        this.contactId = index
        this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: `Confirmar`,
        text: '¿Estas seguro de eliminar el contacto?',
        accept: this.confirmDeleteContact
      })
    },
    async confirmDeleteContact(){
        let response = await ClientDataService.deleteContact({id: this.contacts[this.contactId].id})
        if((response.status/100) == 2){
            this.$vs.notify({title:'Información',text:'El contacto fue eliminado exitosamente!',color:'success',icon:'check'})
            this.contacts.splice(this.contactId, 1)   
        } else {
            this.$vs.notify({title:'Información',text:'Error eliminado el contacto',color:'danger',icon:'error_outline'})                
        }
    },
    async handleRequestContact(){
        this.$v.contact.$touch()
        if (this.$v.contact.$invalid) return;
        
        this.loadingProgress ('#btnConfirm')
        this.confirmStatus = true
            
        if (!this.isUpdating) {
            // New Contact
            let response = await ClientDataService.addContact(this.contact)
            if((response.status/100) == 2){
                this.$vs.loading.close('#btnConfirm .con-vs-loading')
                this.$vs.notify({title:'Información',text:'El contacto fue agregado exitosamente!',color:'success',icon:'check'})
                this.contact = { ...response.data.obj}
                this.contacts.push(this.contact);
                this.closeModalContact();
                this.$v.contact.$reset()
            } else {
                this.$vs.notify({title:'Información',text:'Error agregado el contacto',color:'danger',icon:'error_outline'})                
            }
        } else {
            // Edit Contact
            let response = await ClientDataService.updateContact(this.contact)
            if((response.status/100) == 2){
                this.$vs.loading.close('#btnConfirm .con-vs-loading')
                this.$vs.notify({title:'Información',text:'El contacto fue actualizado exitosamente!',color:'success',icon:'check'})
                // this.contacts.push(this.contact);
                // console.log(response.data.obj.id);
                let posContact = this.contacts.findIndex( item => item.id == response.data.obj.id);
                this.contacts[posContact] = response.data.obj
                this.key++
                // console.log(posContact);
                this.closeModalContact();
                this.$v.contact.$reset()
            } else {
                this.$vs.notify({title:'Información',text:'Error actualiando el contacto',color:'danger',icon:'error_outline'})                
            }
        }

        this.confirmStatus = false;
        this.$vs.loading.close('#btnConfirm .con-vs-loading');

    },
    changePackageStatus(value){
        
      if(this.userInfoData.role != 'Customer'){
        this.packageId   = value
        this.pkgCurrentStatus = this.currentPackStatus(value)
        this.modalActive = true
      }
      
    },
    currentPackStatus(id) {
        let _objPack = this.packages.filter((item) => {
          return id === item.id
        })
        _objPack =  _objPack[0]
        let newStatus = { id: _objPack.statuscode, name: _objPack.statusname}
        return newStatus
    },
    notificationInfo(){
       let _info = "";
        if(this.customer.whatsapp == '1'){
            _info = "Whatsapp, ";
        }
        if(this.customer.bycall == '1'){
            _info += "Llamada, ";
        }
        if(this.customer.bymail == '1'){
            _info += "Correo";
        }
       return _info;
    },
    ...mapActions([
      'addUserInfo'
    ]),
    changePassword(){
        this.loadingProgress ('#btnConfirm')
        this.changePwdStatus = true
        UserDataService.chagePassword(this.objChangePass)
        .then(response => {
            this.changePwdStatus = false
            console.log(response)
            this.$vs.loading.close('#btnConfirm .con-vs-loading')
            this.$vs.notify({title:'Información!',text:'La contraseña fue actualizada exitosamente!',color:'success',icon:'check'})
            this.objChangePass.password = ''
            this.objChangePass.newpassword = ''
            this.objChangePass.confirmPass = ''
            this.$v.$reset()
        })
        .catch(e => {
            console.log(e)
            this.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
            this.changePwdStatus = false
            this.$vs.notify({title:'Información!',text:e.body,color:'danger',icon:'error_outline'})                
        });
    },
    updateRateLocker(){
        this.loadingProgress ('#btnConfirm')
        ClientDataService.updateCustomerRate({ id: this.customer.id, rate: this.customerRate})
        .then(response => {
            console.log(response)
            this.$vs.loading.close('#btnConfirm .con-vs-loading')
            this.$vs.notify({title:'Información!',text:'El costo por libra fue actualizada exitosamente!',color:'success',icon:'check'})
            this.customer.rate = this.customerRate
        })
        .catch(e => {
            console.log(e)
            this.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
            this.$vs.notify({title:'Información!',text: 'Error, actualizando el costo por libra',color:'danger',icon:'error_outline'})                
        });
    },
    retrieveCustomer(id) {
        ClientDataService.getCustomerWithPacks(id)
        .then(response => {
            this.customer = response.data.customer;
            this.cashbackData = response.data.cashback
            this.objChangePass.email = this.customer.email
            this.packages = response.data.packages;
            this.customerRate = this.customer.rate;
            this.cashback.customer = id
            this.isFranquise = this.customer.typecode == '03' ? true : false
            this.contacts    = response.data.contacts
        })
        .catch(e => {
            console.log(e);
            if(e.response.status == 404){
                this.$router.push({ name: "clients"})
                this.$vs.notify({title:'Error!',text:'El cliente no fue encontrado.',color:'danger',icon:'error_outline'})
            }else{
                this.$router.push({ name: "clients"})
                this.$vs.notify({title:'Error!',text:'Error obteniendo los datos del cliente!',color:'danger',icon:'error_outline'})
            }
         });
    },
    retrieveMonths() {
        CashbackDataService.months()
        .then(response => {
            this.months = response.data;
        })
        .catch(e => {
            console.log(e);
            this.$vs.notify({title:'Error!',text:'Error obteniendo los meses!',color:'danger',icon:'error_outline'})
         });
    },
    retrieveStatus() {
        CashbackDataService.getStatus()
        .then(response => {
            this.status = response.data;
        })
        .catch(e => {
            console.log(e);
            this.$vs.notify({title:'Error!',text:'Error obteniendo los status!',color:'danger',icon:'error_outline'})
         });
    },
    handleRequestCashback(){
        this.$v.cashback.$touch()
        if (this.$v.cashback.$invalid) return;
        if (!this.isUpdating) {
            this.newCashback()
        } else {
            this.updateCashback()
        }
    },
    newCashback(){
        const that = this
        that.loadingProgress ('#btnConfirm')
        that.confirmStatus = true
        CashbackDataService.createCashback(that.cashback)
        .then(response => {
            that.confirmStatus = false
            console.log(response)
            that.$vs.loading.close('#btnConfirm .con-vs-loading')
            that.ModalActive = false
            that.$vs.notify({title:'Creado!',text:'El cashback fue creado exitosamente!',color:'success',icon:'check'})
            that.cashback    = new CashbackModel()
            this.cashbackData.push(response.data.obj)
            this.$v.cashback.$reset()
        })
        .catch(e => {
            console.log(e)
            that.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
            that.confirmStatus = false
            that.$vs.notify({title:'Información!',text:'Error creando el cashback',color:'danger',icon:'error_outline'})                
        });
    },
    updateCashback(){
        const that = this
        that.loadingProgress ('#btnConfirm')
        that.confirmStatus = true
        CashbackDataService.update(that.cashback)
        .then(() => {
            that.confirmStatus = false
            that.$vs.loading.close('#btnConfirm .con-vs-loading')
            that.ModalActive = false
            console.log('====', this.cashbackData[that.cashbackIndex])
            this.cashbackData[that.cashbackIndex].amount = that.cashback.amount
            this.cashbackData[that.cashbackIndex].month = that.cashback.month.code
            this.cashbackData[that.cashbackIndex].monthName = that.cashback.month.name
            this.cashbackData[that.cashbackIndex].statuscode = that.cashback.status.code
            this.cashbackData[that.cashbackIndex].statusname = that.cashback.status.name            
            that.cashback    = new CashbackModel() 
            this.$v.cashback.$reset()
            that.$vs.notify({title:'Creado!',text:'El cashback fue modificado exitosamente!',color:'success',icon:'check'})
            
        })
        .catch(e => {
            console.log(e)
            that.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
            that.confirmStatus = false
            that.$vs.notify({title:'Información!',text:'Error actualizando el cashback',color:'danger',icon:'error_outline'})     
        })
    },
    searchCasback(id){
        let obj = this.cashbackData.filter((item) => {
            return id === item.id
        })
        obj =  obj[0]
        let _month  = {code: obj.month, name: obj.monthName}
        let _status = {code: obj.statuscode, name: obj.statusname}
        let cashback = new CashbackModel(obj.id, obj.amount, _month, this.customer.id, _status)
        return cashback
    }    
  }
}
</script>